import { Component, OnInit, ViewEncapsulation, ViewChild, animate, Input, Output, EventEmitter } from '@angular/core';
import { DataService } from '../app-service/data.service';
import { NgbModal, ModalDismissReasons, } from '@ng-bootstrap/ng-bootstrap';


declare var $: any;

@Component({
  selector: 'app-app-body',
  templateUrl: './app-body.component.html',
  styleUrls: ['./app-body.component.css'],
  encapsulation: ViewEncapsulation.None
})


export class AppBodyComponent implements OnInit {

  buttonName: string;
  // A json variable which carries all format type icon with the actual title.
  formatTypes: any = [
    {
      'title': 'Desktop Ads',
      // tslint:disable:max-line-length
      'svg': '<circle class="black-green-fill" cx="58.7" cy="58.4" r="31"/><path class="white-fill black-stroke" d="M47.9,82l-2.3,8.1a1.66,1.66,0,0,0,1.5,2.1H70.2a1.64,1.64,0,0,0,1.6-2L69.6,82A1.62,1.62,0,0,0,68,80.8H49.5A1.86,1.86,0,0,0,47.9,82Z"/><path class="black-fill" d="M88.7,80.9h-60a4.27,4.27,0,0,1-4.3-4.3V35.7a4.27,4.27,0,0,1,4.3-4.3h60A4.27,4.27,0,0,1,93,35.7V76.6A4.33,4.33,0,0,1,88.7,80.9Z"/><path class="white-fill" d="M87.8,77.1H29.7A1.11,1.11,0,0,1,28.6,76V36.3a1.11,1.11,0,0,1,1.1-1.1H87.8a1.11,1.11,0,0,1,1.1,1.1V76A1.11,1.11,0,0,1,87.8,77.1Z"/><path class="green-black-fill" d="M62.4,43l0.7-.7a0.48,0.48,0,0,1,.7,0l0.6,0.6a0.9,0.9,0,0,0,.5.1l0.7-.2a0.54,0.54,0,0,0,.4-0.5V41a0.63,0.63,0,0,1,.5-0.6h1.1a0.54,0.54,0,0,1,.5.5v1.4a0.51,0.51,0,0,0,.4.5L69.1,43a0.61,0.61,0,0,0,.6-0.1l0.5-.5a0.48,0.48,0,0,1,.7,0l0.8,0.7a0.48,0.48,0,0,1,0,.7l-0.7.5c-0.2,0-.2.2-0.1,0.5l0.2,0.5c0.1,0.2.4,0.4,0.5,0.2l0.7-.1a0.63,0.63,0,0,1,.6.5L73,47.3a0.63,0.63,0,0,1-.5.6H71.8a0.51,0.51,0,0,0-.5.4l-0.2.6a0.61,0.61,0,0,0,.1.6L71.7,50a0.48,0.48,0,0,1,0,.7l-0.7.7a0.48,0.48,0,0,1-.7,0l-0.5-.5a0.66,0.66,0,0,0-.6-0.1l-0.6.4a0.59,0.59,0,0,0-.2.5l0.1,0.9a0.51,0.51,0,0,1-.5.6H66.8a0.54,0.54,0,0,1-.5-0.5V51.8a0.51,0.51,0,0,0-.4-0.5l-1.2-.4a0.66,0.66,0,0,0-.6.1l-0.6.5a0.48,0.48,0,0,1-.7,0L62,50.7a0.48,0.48,0,0,1,0-.7l0.5-.6a0.9,0.9,0,0,0,.1-0.5l-0.2-.7a0.37,0.37,0,0,0-.4-0.4l-0.7-.1a0.54,0.54,0,0,1-.5-0.5V46.3a0.54,0.54,0,0,1,.5-0.5H62a0.51,0.51,0,0,0,.5-0.4l0.4-.7a0.61,0.61,0,0,0-.1-0.6l-0.6-.5A2.07,2.07,0,0,1,62.4,43Z"/><circle class="white-fill" cx="67" cy="46.8" r="3.4"/><path class="green-black-fill" d="M53.4,53.8l0.9-.9a0.75,0.75,0,0,1,.9,0L56,53.7a0.62,0.62,0,0,0,.7.1l0.9-.4a0.94,0.94,0,0,0,.5-0.7L58,50.9a0.75,0.75,0,0,1,.7-0.7h1.5a0.75,0.75,0,0,1,.7.7v1.9a0.6,0.6,0,0,0,.5.6l0.8,0.4a1.13,1.13,0,0,0,.8-0.1l0.6-.7a0.64,0.64,0,0,1,.9-0.1l1.1,0.9c0.4,0.2.4,0.7,0,1.1l-0.6.6a0.78,0.78,0,0,0-.1.8l0.4,0.6a0.75,0.75,0,0,0,.7.4l1.1-.1a0.76,0.76,0,0,1,.8.7L68,59.8a0.75,0.75,0,0,1-.7.7H66.2a0.87,0.87,0,0,0-.7.5l-0.2.8a0.83,0.83,0,0,0,.2.8l0.7,0.6a0.52,0.52,0,0,1,.1.9l-1.1,1.2c-0.2.4-.7,0.4-1.1,0l-0.6-.6a0.81,0.81,0,0,0-1.1-.2l-0.8.6a0.82,0.82,0,0,0-.4.6L61.3,67a0.63,0.63,0,0,1-.7.7H59a0.63,0.63,0,0,1-.7-0.7l-0.1-1.3a0.74,0.74,0,0,0-.5-0.6l-1.2-.5a0.82,0.82,0,0,0-.7.1l-0.7.7a0.75,0.75,0,0,1-.9,0l-1.1-1.1a0.75,0.75,0,0,1,0-.9l0.7-.8a0.88,0.88,0,0,0,.1-0.7L53.7,61a1.47,1.47,0,0,0-.6-0.5L52,60.4a0.66,0.66,0,0,1-.6-0.7l0.1-1.3a0.75,0.75,0,0,1,.7-0.7h0.9a0.71,0.71,0,0,0,.7-0.5l0.5-1.1a1.13,1.13,0,0,0-.1-0.8l-0.7-.7A0.44,0.44,0,0,1,53.4,53.8Z"/><circle class="white-fill" cx="59.6" cy="58.9" r="4.6"/><circle class="white-fill" cx="81.4" cy="78.9" r="0.9"/><circle class="white-fill" cx="83.9" cy="78.9" r="0.9"/><circle class="white-fill" cx="86.5" cy="78.9" r="0.9"/>'
    },
    {
      'title': 'Mobile Ads',
      // tslint:disable:max-line-length
      'svg': '<circle class="black-green-fill" cx="59.4" cy="60.9" r="37.5"/><rect x="39" y="30.3" class="white-fill black-stroke" width="41.6" height="60.9"/><path class="white-fill black-stroke" d="M75.8,21.1H43.1c-3.2,0-5.9,2.6-5.9,5.9v67.8c0,3.3,2.7,5.9,5.9,5.9h32.6c3.3,0,5.9-2.7,5.9-5.9V27C81.7,23.8,79,21.1,75.8,21.1z M79.5,91H39.3V30.6h40.2V91z"/><path class="white-fill black-stroke" d="M67.2,24.5H52.4c-0.4,0-0.7-0.3-0.7-0.7v-0.3c0-0.4,0.3-0.7,0.7-0.7h14.8c0.4,0,0.7,0.3,0.7,0.7v0.3 C67.8,24.2,67.5,24.5,67.2,24.5z"/><path class="white-fill black-stroke" d="M67.2,96.2H52.4c-0.4,0-0.7-0.3-0.7-0.7v-0.3c0-0.4,0.3-0.7,0.7-0.7h14.8c0.4,0,0.7,0.3,0.7,0.7v0.3 C67.8,95.9,67.5,96.2,67.2,96.2z"/><circle class="white-fill black-stroke" cx="48.1" cy="23.7" r="0.8"/><path class="grey-black-fill" d="M76.3,89.2H42.1c-0.6,0-1-0.6-1-1.6v-54c0-1,0.4-1.6,1-1.6h34.1c0.6,0,1,0.6,1,1.6v54 C77.3,88.5,76.9,89.2,76.3,89.2z"/><g><path class="black-green-fill transparent-stroke" d="M59.7,47.9l0.8-0.8c0.3-0.3,0.5-0.3,0.8,0l0.6,0.6c0.1,0.1,0.4,0.1,0.5,0.1l0.8-0.3c0.3-0.1,0.4-0.3,0.4-0.5 v-1.4c0-0.3,0.3-0.6,0.5-0.6h1.1c0.3,0,0.5,0.3,0.5,0.5v1.5c0,0.3,0.1,0.4,0.4,0.5l0.6,0.3c0.3,0.1,0.5,0,0.6-0.1l0.5-0.5 c0.3-0.3,0.5-0.3,0.8,0l0.9,0.8c0.3,0.3,0.3,0.6,0,0.8l-0.5,0.5c-0.3,0-0.3,0.3-0.1,0.5l0.3,0.5c0.1,0.3,0.4,0.4,0.5,0.3l0.8-0.1 c0.3,0,0.6,0.3,0.6,0.5l0.1,1.5c0,0.3-0.3,0.6-0.5,0.6h-0.8c-0.3,0-0.4,0.1-0.5,0.4L69,54.1c-0.1,0.3,0,0.5,0.1,0.6l0.5,0.5 c0.3,0.3,0.3,0.5,0,0.8l-0.8,0.9c-0.3,0.3-0.6,0.3-0.8,0l-0.5-0.5c-0.1-0.1-0.5-0.3-0.6-0.1l-0.6,0.4c-0.1,0.1-0.3,0.3-0.3,0.5 l0.1,1c0,0.4-0.3,0.6-0.5,0.6h-1.3c-0.3,0-0.5-0.3-0.5-0.5v-1c0-0.3-0.1-0.4-0.4-0.5l-1.3-0.4c-0.3-0.1-0.4,0-0.6,0.1L61.1,57 c-0.3,0.3-0.5,0.3-0.8,0l-0.9-0.9c-0.3-0.3-0.3-0.5,0-0.8l0.5-0.6c0.1-0.1,0.1-0.4,0.1-0.5l-0.3-0.8c0-0.3-0.1-0.4-0.4-0.4 l-0.8-0.1c-0.3,0-0.5-0.3-0.5-0.5v-1c0-0.3,0.3-0.5,0.5-0.5h0.8c0.3,0,0.4-0.1,0.5-0.4l0.4-0.8c0.1-0.3,0-0.5-0.1-0.6l-0.6-0.5 C59.5,48.4,59.4,48,59.7,47.9z"/><circle class="grey-black-fill" cx="64.6" cy="51.9" r="3.7"/></g><g><path class="black-green-fill transparent-stroke" d="M49.9,59.4l1-1c0.3-0.3,0.8-0.3,1,0l0.9,0.9c0.3,0.3,0.5,0.3,0.8,0.1l1-0.4c0.3-0.1,0.5-0.4,0.5-0.8L55,56.4 c0-0.4,0.4-0.8,0.8-0.8h1.6c0.4,0,0.8,0.4,0.8,0.8v2c0,0.3,0.1,0.5,0.5,0.6l0.9,0.4c0.3,0.1,0.6,0,0.9-0.1l0.6-0.8 c0.3-0.3,0.8-0.4,1-0.1l1.1,1c0.4,0.3,0.4,0.8,0,1.1l-0.8,0.8c-0.3,0.3-0.3,0.6-0.1,0.9l0.4,0.6c0.1,0.3,0.5,0.5,0.8,0.4l1.1-0.1 c0.4,0,0.8,0.3,0.9,0.8l0.1,2c0,0.4-0.4,0.8-0.8,0.8h-1.1c-0.3,0-0.6,0.3-0.8,0.5L62.7,68c-0.1,0.3,0,0.6,0.3,0.9l0.8,0.6 c0.4,0.3,0.4,0.8,0.1,1l-1.1,1.3c-0.3,0.4-0.8,0.4-1.1,0l-0.6-0.6c-0.4-0.4-0.8-0.4-1.1-0.3l-0.9,0.6c-0.3,0.1-0.4,0.4-0.4,0.6 l0.1,1.4c0,0.4-0.3,0.8-0.8,0.8h-1.8c-0.4,0-0.8-0.3-0.8-0.8l-0.1-1.4c0-0.3-0.3-0.5-0.5-0.6L53.5,71c-0.3-0.1-0.6,0-0.8,0.1 l-0.8,0.8c-0.3,0.3-0.8,0.3-1,0l-1.1-1.1c-0.3-0.3-0.3-0.8,0-1l0.8-0.9c0.1-0.3,0.3-0.5,0.1-0.8l-0.4-1c-0.1-0.3-0.4-0.4-0.6-0.5 l-1.1-0.1c-0.4,0-0.6-0.4-0.6-0.8l0.1-1.4c0-0.4,0.4-0.8,0.8-0.8h1c0.3,0,0.6-0.1,0.8-0.5l0.5-1.1c0.1-0.3,0-0.6-0.1-0.9l-0.8-0.8 C49.7,60.2,49.7,59.7,49.9,59.4z"/><circle class="grey-black-fill" cx="56.6" cy="65" r="4.9"/></g>'
    },
    {
      'title': 'Video Ads',
      // tslint:disable:max-line-length
      'svg': '<circle class="black-green-fill" cx="62.69" cy="63.64" r="35.4"/><path class="white-fill black-stroke" d="M46.39,58.14h27.8v23.8a4,4,0,0,1-4,4H34.49a4,4,0,0,1-4-4V54.24a4,4,0,0,1,4-4h35.7a4,4,0,0,1,4,4H46.39v3.9h0Zm0,16.5a2.8,2.8,0,1,1-2.8,2.8,2.86,2.86,0,0,1,2.8-2.8h0Z"/><path class="white-fill black-stroke" d="M91.19,48.64c1-.5,1,0.3,1,2.5v35.7c0,2.2,0,1.7-1,.7l-12-12.8c-2.9,0-3.2,0-4.8-.1V62.74c1.1,0,1.1,0,4.3-.1Z"/><path class="white-fill black-stroke" d="M23.79,58.94c-0.2.1-.2-0.1-0.1-0.6l2.1-7.7c0.1-.5.1-0.4,0.3-0.1l1.9,3.4c0.6,0.2,2.3.6,2.7,0.7v2.9c-0.2-.1-2.5-0.7-3.2-0.9Z"/><path class="white-fill" d="M38.89,48.84a9.11,9.11,0,0,1-.5-18.2h0.5a9.11,9.11,0,0,1,.5,18.2h-0.5Z"/><path class="green-black-fill" d="M38.89,32.14a7.61,7.61,0,0,1,.5,15.2h-0.5a7.61,7.61,0,0,1-.5-15.2h0.5m0-3h-0.6a10.56,10.56,0,0,0-9.9,11.3,10.45,10.45,0,0,0,10.5,9.9h0.6a10.61,10.61,0,0,0-.6-21.2h0Z"/><path class="white-fill" d="M62.39,48.54a12.05,12.05,0,0,1-.6-24.1h0.7a12.07,12.07,0,0,1,.7,24.1h-0.8Z"/><path class="green-black-fill" d="M62.39,26.34a10.05,10.05,0,0,1,.5,20.1h-0.6a10.05,10.05,0,0,1-.4-20.1h0.5m0-4h-0.8a14.06,14.06,0,0,0,.8,28.1h0.8a14.06,14.06,0,0,0-.8-28.1h0Z"/><circle class="black-fill" cx="37.29" cy="36.15" r="1.3" transform="translate(-2.01 2.19) rotate(-3.28)"/><circle class="black-fill" cx="37.89" cy="43.24" r="1.3" transform="translate(-2.41 2.24) rotate(-3.28)"/><circle class="black-fill" cx="35.29" cy="40.14" r="1.3" transform="translate(-2.24 2.08) rotate(-3.28)"/><circle class="black-fill" cx="41.99" cy="41.54" r="1.3" transform="translate(-2.31 2.47) rotate(-3.28)"/><circle class="black-fill" cx="41.09" cy="37.54" r="1.3" transform="translate(-2.08 2.41) rotate(-3.28)"/><circle class="black-fill" cx="60.79" cy="31.95" r="1.5" transform="translate(-1.73 3.53) rotate(-3.28)"/><circle class="black-fill" cx="61.49" cy="40.24" r="1.5" transform="translate(-2.2 3.58) rotate(-3.28)"/><circle class="black-fill" cx="58.39" cy="36.54" r="1.5" transform="translate(-2 3.4) rotate(-3.28)"/><circle class="black-fill" cx="66.19" cy="38.14" r="1.5" transform="translate(-2.07 3.85) rotate(-3.28)"/><circle class="black-fill" cx="65.09" cy="33.54" r="1.5" transform="translate(-1.81 3.78) rotate(-3.28)"/>'
    },
    {
      'title': 'Native Ads',
      // tslint:disable:max-line-length
      'svg': '<circle class="black-green-fill" cx="59.9" cy="59.4" r="37.5"/><rect class="white-fill black-stroke" x="39.5" y="28.8" width="41.6" height="60.9"/><path class="white-fill black-stroke" d="M76.3,19.6H43.6a5.91,5.91,0,0,0-5.9,5.9V93.3a5.91,5.91,0,0,0,5.9,5.9H76.2a5.91,5.91,0,0,0,5.9-5.9V25.5A5.83,5.83,0,0,0,76.3,19.6ZM80,89.5H39.8V29.1H80V89.5Z"/><path class="white-fill black-stroke" d="M67.7,23H52.9a0.68,0.68,0,0,1-.7-0.7V22a0.68,0.68,0,0,1,.7-0.7H67.7a0.68,0.68,0,0,1,.7.7v0.3A0.84,0.84,0,0,1,67.7,23Z"/><path class="white-fill black-stroke" d="M67.7,94.7H52.9a0.68,0.68,0,0,1-.7-0.7V93.7a0.68,0.68,0,0,1,.7-0.7H67.7a0.68,0.68,0,0,1,.7.7V94A0.84,0.84,0,0,1,67.7,94.7Z"/><circle class="white-fill black-stroke" cx="48.6" cy="22.2" r="0.8"/><path class="green-black-fill" d="M77.9,81.6H61.4a0.47,0.47,0,0,1-.5-0.5v-17a0.47,0.47,0,0,1,.5-0.5H77.9a0.47,0.47,0,0,1,.5.5v17A0.47,0.47,0,0,1,77.9,81.6Z"/><circle class="cls-7" cx="77.6" cy="64.5" r="1.9"/><line class="white-stroke" x1="78.4" y1="63.6" x2="76.6" y2="65.5"/><line class="white-stroke" x1="76.6" y1="63.6" x2="78.5" y2="65.4"/><path class="grey-fill" d="M77,38.1H43.3a1.37,1.37,0,0,1-1.4-1.4V32.6a1.37,1.37,0,0,1,1.4-1.4H77a1.37,1.37,0,0,1,1.4,1.4v4.1A1.43,1.43,0,0,1,77,38.1Z"/><path class="grey-fill" d="M58.2,62.1H43.1a1.22,1.22,0,0,1-1.2-1.2V40.7a1.22,1.22,0,0,1,1.2-1.2H58.2a1.22,1.22,0,0,1,1.2,1.2V60.9A1.22,1.22,0,0,1,58.2,62.1Z"/><path class="grey-fill" d="M77.1,62.1h-15a1.32,1.32,0,0,1-1.3-1.3v-20a1.32,1.32,0,0,1,1.3-1.3h15a1.32,1.32,0,0,1,1.3,1.3v20A1.32,1.32,0,0,1,77.1,62.1Z"/><path class="grey-fill" d="M58.7,71.8h-16a0.68,0.68,0,0,1-.7-0.7V64.3a0.68,0.68,0,0,1,.7-0.7h16a0.68,0.68,0,0,1,.7.7v6.8A0.75,0.75,0,0,1,58.7,71.8Z"/><path class="grey-fill" d="M58.7,81.6h-16a0.68,0.68,0,0,1-.7-0.7V74a0.68,0.68,0,0,1,.7-0.7h16a0.68,0.68,0,0,1,.7.7v6.9A0.75,0.75,0,0,1,58.7,81.6Z"/><path class="grey-fill" d="M59.4,89.3H41.9V83.7a0.65,0.65,0,0,1,.6-0.6H58.7a0.65,0.65,0,0,1,.6.6v5.6h0.1Z"/><path class="grey-fill" d="M78.4,89.3H60.9V83.7a0.68,0.68,0,0,1,.7-0.7H77.8a0.68,0.68,0,0,1,.7.7v5.6H78.4Z"/>'
    }
  ];

  // Local variables to get data from the json file.
  formatSize = {};
  formatData = {};
  tempstr;
  show = false;

  adtypes = '';
  subadtypes = '';
  creativeId = '';
  adtitle = '';
  keyname = '';
  adsize;
  getlengthadtype: number;
  IconName = '';
  thirdPara = '';
  modal;
  btn;
  span;
  modalpopup;
  iconurl;

  @Output() modalpopupurl = new EventEmitter<any>();

  // service request to get the json data using the dataservice
  // Format size data according to type
  public getSizeData() {
    this._dataService
      .getData('../assets/jsonData/formatSize.json')
      .subscribe(res => {
        const x = res.json();
        this.formatSize = x;
      }, error => {
        console.log(error);
      });
  }

  // service request to get the json data using the dataservice
  // Formats data according to type or size
  public getFormatData() {
    this._dataService
      .getData('../assets/jsonData/formatData.json')
      .subscribe(res => {
        const x = res.json();
        this.formatData = x;
        this.onreloadfunction();
        //console.log(this.formatData);
      }, error => {
        console.log(error);
      });
  }


  public hide() {
    setTimeout(function() {
    	document.getElementById('copied').style.display = 'none';
    }, 800);
  }

  public shareurl() {
    this.iconurl = window.location.href;
    (document.getElementById('shareurl') as HTMLInputElement).value = this.iconurl;
    //console.log(this.iconurl);
    const linkurl = document.getElementById('shareurl') as HTMLInputElement;
    linkurl.select();
    document.execCommand('Copy');

    document.getElementById('copied').style.display = 'inline';
    this.hide();

  }

  public mobilescroll() {
    if (window.innerWidth >= 320 && window.innerWidth <= 768) {
      //console.log('this is mobile format');
      //console.log('scrolling');
    }
  }

  public onreloadfunction() {

    const a = window.location.hash.split('/');
    if (a[3] !== undefined) {
      this.thirdPara = decodeURI(a[3]);
    }

    function titleCase(str) {
      str = str.toLowerCase().split(' ');
      for (let i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
      }
      //console.log(str.join(' '));
      return str.join(' ');
    }

    titleCase(this.thirdPara);

    if (window.location.hash !== '') {
      console.log('hash value present');
      this.createFormatIcons(a[1], a[2], false);
      this.sendDetails(a[1], a[2], titleCase(this.thirdPara));
    }
  }

  // Getting the details from parent when the item selected in typeahead search box.
  public getFormatDataFromApp(e) {
    const tempvar = e.split('>');
    this.createFormatIcons(tempvar[1], tempvar[0], true);
    this.sendDetails(tempvar[1], tempvar[0], tempvar[2]);
  }

  // Getting the data from sort by size input area.
  public getFormatDetailsFromApp(e) {
    const tempvar = e.split('>');
    this.createFormatIcons(tempvar[0], tempvar[1], false);
  }

  // Methods to make scrolling smoother
  public scrollWin(x, y) {
    const val = (window.innerWidth > 768) ? 800 : 400;
    if (y < val) {
      this.smoothScrollReverse(val, x);
    } else {
      if (window.scrollY < 350) {
        this.smoothScroll(0, y);
      }

    }
  }

  // Scrolling down
  public smoothScroll(h, y) {
    const i = h || 0;
    if (i < y) {
      setTimeout(() => {
        window.scrollTo(0, i);
        this.smoothScroll((i + 20), y);
      }, 10);
    }
  }

  public scrollBlock(e) {
    e.preventDefault();
  }

  // scrolling up
  public smoothScrollReverse(x, y) {
    const i = x;

    window.addEventListener('mousewheel', this.scrollBlock);

    if (i >= y) {
      setTimeout(() => {
        window.scrollTo(0, i);
        this.smoothScrollReverse((i - 20), y);
      }, 10);
    }

    const that = this;

    setTimeout(function() {
      window.removeEventListener('mousewheel', that.scrollBlock);
    }, 1500);

  }

  // public userscrolldisable(){
  //   window.addEventListener('mousewheel', function(e) {
  //       e.preventDefault();
  //   });
  // }

  // public userscrollallow(){
  //   setTimeout(function(){
  //     window.removeEventListener('mousewheel', function(e){
  //       return true;
  //     });
  //   },1500);
  // }

  // Method responsible for creating or adding all format icons to the body.
  public createFormatIcons(type, size, bool) {

    const smallType = type.replace(/ +/g, '').toLowerCase();
    const smallSize = size.replace(/ +/g, '').toLowerCase();

    //console.log('createFormatIcons ' + type.replace(/ +/g, '').toLowerCase());
    //console.log('createFormatIcons ' + size.replace(/ +/g, '').toLowerCase());
    //console.log('createFormatIcons ' + bool);
    this.adtypes = type.replace(/ +/g, '').toLowerCase();
    // this.subadtypes = '/'+size.replace(/ +/g,"");
    this.subadtypes = size.replace(/ +/g, '').toLowerCase();

    // if('/'+this.adtypes == this.subadtypes){
    //   this.subadtypes = '';
    // }

    window.location.hash = `#/${smallType}/${smallSize}`;


    const ftype = type.replace('ads', ' Ads');
    const fsize = size.replace('banner', ' Banner');

    if (size !== 'videoads' && size !== 'nativeads') {
      this._dataService.changebuttonName((ftype + ' - ' + fsize).replace(/\b\w/g, l => l.toUpperCase()));
    } else {
      this._dataService.changebuttonName((ftype).replace(/\b\w/g, l => l.toUpperCase()));
    }
    const temptype = type.toLowerCase().replace(/ /g, '').replace(/-/g, '');
    const tempsize = size.toLowerCase().replace(/ /g, '').replace(/-/g, '');
    const hrcon = document.getElementById('hr-con');
    const iconHolder = document.getElementById('icon-holder');
    const adFormatHeading = document.getElementById('adFormatHeading');
    adFormatHeading.classList.add('adformatheadingstyle');
    adFormatHeading.innerHTML = 'AD FORMATS';
    iconHolder.innerHTML = '';
    let tempstr = '';

    this.getlengthadtype = Object.keys(this.formatData[0][temptype]).length;

    //console.log(Object.keys(this.formatData[0][temptype]));

    // if(Object.keys(this.formatData[0][temptype])[0]=='leaderboard'){
    //   this.adtypes = 'desktopads';
    // }
    // else if(Object.keys(this.formatData[0][temptype])[0]=='responsive'){
    //   this.adtypes = 'mobileads';
    // }
    // else{
    //   this.adtypes = Object.keys(this.formatData[0][temptype])[0];
    // }

    // alert(this.formatData[0][temptype][tempsize].length);

    for (let i = 0; i < this.formatData[0][temptype][tempsize].length; i++) {
      console.log("aa",this.formatData[0][temptype][tempsize][i].viewbox);
      this.adtitle = this.formatData[0][temptype][tempsize][i].title.replace(/ +/g, '_').toLowerCase();
      var viewBoxCondition = this.formatData[0][temptype][tempsize][i].viewbox ? 'viewBox="0, 0, 120, 120"' : 'viewBox="0, 0, 90, 90"'
      tempstr += '<div class="col-3 col-sm-4 col-md-4 col-lg-3 col-xl-2" id="' + this.adtypes + '/' + this.subadtypes + '/' + this.adtitle + '" style="text-align: center">' +
        '<div class="cover-svg" id="svg-id' + i + '">' +
        '<svg '+viewBoxCondition+'>' + this.formatData[0][temptype][tempsize][i].svg + '<svg>' +
        '</div>' +
        '<br>' +
        '<label class="formatsize-icon-labels">' + this.formatData[0][temptype][tempsize][i].title + '</label>' +
        '</div>';
    }
    iconHolder.innerHTML = tempstr; // Dynamically adding the string to innerhtml to add icons

    // hrcon.style.display = (window.innerWidth < 577) ? "block" : "none";
    // Binding click event to all the format icons
    for (let i = 0; i < this.formatData[0][temptype][tempsize].length; i++) {
      iconHolder.children[i].addEventListener('click', (event: Event) => {
        this.sendDetails(temptype, tempsize, iconHolder.children[i].children[2].innerHTML);
        // window.history.replaceState(null, null, "/" + iconHolder.children[i].getAttribute('id') + "");
      });
    }

    if (!bool) {
      if (window.innerWidth > 768) {
        this.scrollWin(0, 800); // conditionally scrolling to make scrolling clear
      } else {
        this.scrollWin(0, 400); // conditionally scrolling to make scrolling clear
      }
    }

    if (window.innerWidth < 768) {
      console.log('less than 768');
    }

  }

  // This method is responsible for making ad preview when an item is got clicked.
  public sendDetails(type, size, name) {
    //console.log('sendDetails ' + type);
    //console.log('sendDetails ' + size);
    //console.log('sendDetails ' + name);

    window.location.hash = `#/${type}/${size}/${name}`;
    //console.log(window.location.hash);
    const modal = document.getElementById('adModal');
    const modalFrame = document.getElementById('modalFrame');
    const mobileCon = document.getElementById('mobile-adcontainer');
    const iframeCon = document.getElementById('iframe-con');

    setTimeout(function() {
      document.getElementById('loadingfunction').style.pointerEvents = 'none';
    }, 1);

    setTimeout(function() {
      document.getElementById('loadingfunction').style.pointerEvents = 'auto';
    }, 3200);

    // for mobile screens
    if (window.innerWidth < 768) {
      for (let i = 0; i < this.formatData[0][type][size].length; i++) {
        if (name === this.formatData[0][type][size][i].title) {
          let url = 'https://airtory.adtag.org/';
          if (size === 'responsive' || type === 'desktop' || type === 'standard' || type === 'videoads') {
            url = '/assets/preview#' + this.formatData[0][type][size][i].creativeId;
          } else if (type === 'nativeads') {
            url += 'native#' + this.formatData[0][type][size][i].creativeId;
          } else if (type === 'interstitials') {
            url += 'preserve#' + this.formatData[0][type][size][i].creativeId;
            document.getElementById('mobilepopupmodal').style.height = this.formatData[0][type][size][i].height + 'px';
            document.getElementById('mobilepopupmodal').style.width = this.formatData[0][type][size][i].width + 'px';
          } else {
	    document.getElementById('mobilepopupmodal').setAttribute('name', 'export-preview-frame');
            url = '/assets/preview?id=' + this.formatData[0][type][size][i].creativeId + '&height=' + this.formatData[0][type][size][i].height + '&width=' + this.formatData[0][type][size][i].width;
          }
          // window.open(url, '_blank');
          this.modalpopupurl.emit(url);

          //console.log(url);
          if (url == null) {
            document.getElementById('mobilepopupmodal').style.backgroundColor = 'white';
          } else {
            document.getElementById('mobilepopupmodal').style.backgroundColor = '';
          }
          document.getElementById('mobilepopupmodal').setAttribute('src', url);
          document.getElementById('mobilepopupmodal').style.display = 'inline';
          document.getElementById('closemobilepopup').style.display = 'inline';
          document.getElementById('main-body-id').style.opacity = '0.2';
          document.getElementById('header-id').style.opacity = '0.2';
          document.getElementById('footer-id').style.opacity = '0.2';
          // document.getElementById('appbodycontainer').style.opacity = '0.6';
          // document.getElementById('appbodycontainer').style.backgroundColor = 'black';
        }
      }

      return;
    }

    this.scrollWin(0, 80); // Scrolling to top when an adformat is selected for clear view of preview.

    // getting variable for easy access of html element.
    const adspace = document.getElementById('ad-container');
    const addetails = document.getElementById('ad-details-container');
    const usecase = document.getElementById('ad-usecase-container');
    const buttonHolder = document.getElementById('button-holder');
    const button = document.getElementById('button-customize');
    const buttonshare = document.getElementById('button-share');
    const buttonbuildguide = document.getElementById('button-buildguide');
    buttonHolder.style.borderBottomLeftRadius = '0px'; // Changing the border radius
    buttonHolder.style.borderBottomRightRadius = '0px'; // Changing the border radius
    button.style.display = 'block'; // Making the customize button visible
    buttonshare.style.display = 'block'; // Making the share button visible
    buttonbuildguide.style.display = 'block'; // Making the buildguide button visible
    addetails.style.display = 'block'; // Making add details visible
    document.getElementById('ad-usecases-container').style.display = 'block'; // Making usecases visible

    // window location hash value to be get from here
    const a = window.location.hash.split('/');

    if (a[3] === '') {
      //console.log('this is working');
      document.getElementById('ad-usecases-container').style.display = 'none';
      // buttonHolder.style.display = 'none';
      document.getElementById('button-customize').style.display = 'none';
      document.getElementById('button-share').style.display = 'none';
      document.getElementById('button-buildguide').style.display = 'none';
      addetails.style.display = 'none';
    }


    // Changing the default content of ad-container to show the preview of the formats
    for (let i = 0; i < this.formatData[0][type][size].length; i++) {

      if (name.replace(/ /g,'').toLowerCase() === this.formatData[0][type][size][i].title.replace(/ /g,'').toLowerCase()) {
        const clicked = document.getElementById('svg-id' + i);
        addetails.innerHTML = '<h3>' + this.formatData[0][type][size][i].title + '</h3><p>' + this.formatData[0][type][size][i].description + '</p>';
        usecase.innerHTML = this.getusecase(this.formatData[0][type][size][i].usecase);
        if (type === 'mobileads') {
          if(this.formatData[0][type][size][i]["id"] === "amp3" || this.formatData[0][type][size][i]["id"] === "amp5") {
            let string;
            // let stylevar = `style=width:${ this.formatData[0][type][size][i].width + 30}px;height:${ this.formatData[0][type][size][i].height}px`;
            
            string = '<div class="ad-bg-conatiner">' +
            '<img class="preview-background" src="../../assets/images/mobile-flat_16-copy.png">' +
            '<div class="preview-box" style="left:-151px;width:350px;"><iframe id="export-preview-frame" class="iframe" style="overflow:hidden !important;" height="300px !important"  name="export-preview-frame" src="../../assets/preview.html#' + this.formatData[0][type][size][i].creativeId + '"></iframe></div>' +
            '</div>';
            adspace.innerHTML = string;
            adspace.style.backgroundImage = 'none';
            let observer = new MutationObserver(function (mutationsList, observer) {
              document.getElementById('export-preview-frame').style.height = "300px"
            });

            observer.observe(document.getElementById('export-preview-frame'), {
              attributes: true
            });
          }
          else if(this.formatData[0][type][size][i]["id"] === "amp4") {
            let string;

            string = '<div class="ad-bg-conatiner">' +
            '<img class="preview-background" src="../../assets/images/mobile-flat_16-copy.png">' +
            '<div class="preview-box" style="left:-130px;width:350px;"><iframe id="export-preview-frame" class="iframe" style="overflow:hidden !important;" height="300px !important"  name="export-preview-frame" src="../../assets/preview.html#' + this.formatData[0][type][size][i].creativeId + '"></iframe></div>' +
            '</div>';
            adspace.innerHTML = string;
            adspace.style.backgroundImage = 'none';
          }
          
          else {
            let string;
            string = '<div class="ad-bg-conatiner">' +
              '<img class="preview-background" src="../../assets/images/mobile-flat_16-copy.png">' +
              '<div class="preview-box"><iframe id="export-preview-frame" class="iframe" name="export-preview-frame" width="' + this.formatData[0][type][size][i].width + '" height="' + this.formatData[0][type][size][i].height + '" src="../../assets/preview.html#' + this.formatData[0][type][size][i].creativeId + '"></iframe></div>' +
              '</div>';
            adspace.innerHTML = string;
            adspace.style.backgroundImage = 'none';
          }
         
        } else if (type === 'nativeads') {
          let string;
          string = '<div class="ad-bg-conatiner">' +
            '<img class="preview-background" src="../../assets/images/mobile-flat_16-copy.png">' +
            '<div class="preview-box"><iframe id="export-preview-frame" class="iframe" name="export-preview-frame"  width="' + this.formatData[0][type][size][i].width + '" height="' + this.formatData[0][type][size][i].height + '" src="https://studio.airtory.com/native#' + this.formatData[0][type][size][i].creativeId + '"></iframe></div>' +
            '</div>';
          adspace.innerHTML = string;
          adspace.style.backgroundImage = 'none';
        } else if (size === 'videoads') {
          let stylevar = '';
          stylevar = 'style="top:-205px; left:-252px;"';
          let string;
          string = '<div class="ad-bg-conatiner  ad-bg-conatiner-desk">' +
            '<img class="preview-background-desk" src="https://cdn.airtory.com/099cf0da14a1b839c4b16bcf050dff76_desktopflatArtboard9.png">' +
            '<div class="preview-box-desk" ' + stylevar + ' ><iframe class="iframe" name="export-preview-frame"  width="' + this.formatData[0][type][size][i].width + '" height="' + this.formatData[0][type][size][i].height + '" src="https://studio.airtory.com/preserve#' + this.formatData[0][type][size][i].creativeId + '"></iframe></div>' +
            '</div>';
          adspace.innerHTML = string;
          adspace.style.backgroundImage = 'none';
        } else {
          let stylevar = '';
          let frameSRC = 'https://studio.airtory.com/preserve#' + this.formatData[0][type][size][i].creativeId;
          let frameWidth = this.formatData[0][type][size][i].width;
          let frameHeight = this.formatData[0][type][size][i].height;

          if (size === 'leaderboard') {
            stylevar = 'style="top:33px; left:-282px; "';
            if(this.formatData[0][type][size][i].height == 300) {
              stylevar = 'style="top:-132px; left:-282px; "';
            }
          }
          if (size === 'square') {
            stylevar = 'style="top:-233px; right:-19px; "';
          }
          if (size === 'halfpage') {
            stylevar = 'style="top:-234px; left:115px; transform: scale(0.56);"';
          }
          if (size === 'standardbanner') {
            stylevar = 'style="top:-234px; left:-282px; transform: scale(0.56);"';
          }
          if (size === 'skins' || size === 'native') {
            stylevar = 'style="transform: translateY(-70px) scale(.32);transform-origin: center center;"';
            frameSRC = 'https://studio.airtory.com/inline#' + this.formatData[0][type][size][i].creativeId;
          }

          if(this.formatData[0][type][size][i].height == 1200) {
            frameHeight = 1050;
          }

          let string;
          string = '<div class="ad-bg-conatiner  ad-bg-conatiner-desk">' +
            '<img class="preview-background-desk" src="https://cdn.airtory.com/099cf0da14a1b839c4b16bcf050dff76_desktopflatArtboard9.png">' +
            '<div class="preview-box-desk" ' + stylevar + ' ><iframe class="iframe" name="export-preview-frame"  width="' + frameWidth + '" height="' + frameHeight + '" src="' + frameSRC + '"></iframe></div>' +
            '</div>';
          adspace.innerHTML = string;
          adspace.style.backgroundImage = 'none';
        }
        button.innerHTML = '<a href="https://studio.airtory.com/#/step4/' + this.formatData[0][type][size][i].id + '" target="_blank" class="customize-btn">CUSTOMIZE</a>';
        buttonbuildguide.innerHTML = '<a href="https://studio.airtory.com/studio/guide/' + this.formatData[0][type][size][i].id + ' " target="_blank" class="buildguide-btn">BUILD GUIDE</a>';
        clicked.style.borderColor = '#4caf50';
        clicked.style.backgroundColor = 'white';
      } else {
        const clicked = document.getElementById('svg-id' + i);
        clicked.style.borderColor = 'transparent';
        clicked.style.backgroundColor = '#ebebeb';
      }
    }
    //$('#button-holder').classList.remove("hide-control-btns");
  }

  public closeModal() {
    const modal = document.getElementById('adModal');
    modal.style.display = 'none';
    modal.style.opacity = '0';
    $('#adModal').modal('hide');
  }
  // Styling the usecase
  public getusecase(usecase) {
    this.tempstr = usecase.split(',');
    let str = '';
    if (this.tempstr.length > 1) {
      for (let i = 0; i < 6; i++) {
        str += '<label class="tag">' + this.tempstr[i] + '</label>';
      }
      str += '<label class="tags">[...]</label>';
    }
    return str;
  }

  // turning and adding or removing usecases on arrowclick
  public arrowClick(x) {
    const usecase = document.getElementById('ad-usecase-container');
    const arrow = document.getElementById('arrow');
    let str = '';
    if (x) {
      for (let i = 0; i < this.tempstr.length; i++) {
        str += '<label class="tag">' + this.tempstr[i] + '</label>';
      }
      arrow.style.transform = 'rotate(-180deg)';
    } else {
      for (let i = 0; i < 6; i++) {
        str += '<label class="tag">' + this.tempstr[i] + '</label>';
      }
      str += ' [...]';
      arrow.style.transform = 'rotate(0deg)';
    }
    usecase.innerHTML = str;
  }

  constructor(private _dataService: DataService) { }

  ngOnInit() {
    // to get json data in local variables when the page load
    this.getSizeData();
    this.getFormatData();
    this._dataService.currentbuttonName.subscribe(name => this.buttonName = name);
    this.mobilescroll();
  }

  // getting data from another component
  getTypeSize(ev) {
    const tempvar = ev.split('-');
    this.createFormatIcons(tempvar[0], tempvar[1], false);
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/demo.airtory.com-stage/src/app/app-body/app-body.component.ts